import Item from '@/models/Subchapter';
import { SubchaptersProps } from '../book/Subchapters';
import { twJoin } from 'tailwind-merge';
import SimpleTextIcon from '@/components/ui/custom/SimpleTextIcon';
import { DashedCircleIcon } from '@/components/icons';

type Props = Omit<SubchaptersProps, 'selectedChapter'> & {
  subchapter: Item;
};

export default function Subchapter(props: Props) {
  const { activeSubchapterId, subchapter, onChapterOrSubchapter } = props;
  return (
    <li
      role="button"
      onClick={() => onChapterOrSubchapter?.(subchapter)}
      className={twJoin(
        'flex w-full items-center gap-2.5 px-1.5 py-0.5 rounded-md font-500 h-6',
        activeSubchapterId === subchapter.id
          ? 'bg-secondary-content underline decoration-secondary'
          : '',
      )}
    >
      <SimpleTextIcon
        icon={<DashedCircleIcon className="w-4 h-4" />}
        tooltipText={subchapter.title}
        title={subchapter.title}
        tooltip
        truncate
        className={{
          base: 'gap-1',
          text: 'normal-case',
          figure: 'bg-transparent text-base-content p-0',
        }}
      />
    </li>
  );
}
